import React from 'react';
import PropTypes from 'prop-types';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { Icon, ListItem, List } from '@material-ui/core';

const styles = theme => ({
  popover: {
    pointerEvents: 'none',
  },
  paper: {
    padding: theme.spacing.unit,
  },
  iconButton: {
    fontSize: '25px',
    marginBottom: '-7px'
  }
});
class MissingFilesPopper extends React.Component {


  state = {
    anchorEl: null,
  };

  handlePopoverOpen = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handlePopoverClose = () => {
    this.setState({ anchorEl: null });
  };

  renderMissingFiles = () => {
    return this.props.missingFiles.map(filename => {
      return (
        <ListItem key={filename} divider={true}><Typography>{filename}</Typography></ListItem>
      );
    })}


  render() {
    const { classes } = this.props;
    const { anchorEl } = this.state;
    const open = !!anchorEl;

    return (
      <React.Fragment>
        <Typography onMouseEnter={this.handlePopoverOpen}
        onMouseLeave={this.handlePopoverClose}>
        <Icon
          aria-owns={open ? 'mouse-over-popover' : undefined}
          aria-haspopup="true"
          style={{marginRight:'6px'}}
          color="error"
          className={classes.iconButton}

        >
          error
        </Icon>
        {this.props.fileName}
        </Typography>
        <Popover
          id="mouse-over-popover"
          className={classes.popover}
          classes={{
            paper: classes.paper,
          }}
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          onClose={this.handlePopoverClose}
          disableRestoreFocus
        >
          <List>
          <ListItem divider={true} key="header"><Typography>Missing files</Typography></ListItem>
          {this.renderMissingFiles()}
          </List>
        </Popover>
      </React.Fragment>
    );
  }
}

MissingFilesPopper.propTypes = {
  classes: PropTypes.object.isRequired,
  missingFiles: PropTypes.array.isRequired,
  fileName: PropTypes.string
};

export default withStyles(styles)(MissingFilesPopper);
